import {Component, HostListener, inject, OnInit} from '@angular/core';
import {LayoutService} from '../../../../core/services/layout.service';
import {AsyncPipe, NgClass} from "@angular/common";
import {Observable} from "rxjs";
import {Router} from '@angular/router';
import {AuthService} from '../../../../core/services/auth.service';
import {SafeLoginDetails} from '../../../../core/models/safe-login-details';

@Component({
  selector: 'app-header',
  imports: [
    AsyncPipe,
    NgClass,
  ],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss',
})
export class AppHeaderComponent implements OnInit {

  isMobileOpen$!: Observable<boolean>;
  isProfileOpen = false;
  userDetails!: SafeLoginDetails | null;

  constructor(public layoutService: LayoutService, private authService: AuthService, private router: Router) {
    // ✅ Safe: constructor runs AFTER dependency injection
    this.isMobileOpen$ = this.layoutService.isMobileOpen$;
  }

  ngOnInit() {
    this.userDetails = this.authService.getUser();
    console.log(this.userDetails);
  }

  toggleSidebar() {
    if (window.innerWidth < 1200) {
      this.layoutService.toggleMobileOpen();
    } else {
      this.layoutService.toggleExpanded();
    }
  }

  getWelcomeText(userType?: string): string {

    const roleMap: Record<string, string> = {
      ADMIN: 'Welcome Admin',
    };

    return roleMap[userType ?? ''] || 'Welcome User';
  }


  toggleProfileDropdown(): void {
    this.isProfileOpen = !this.isProfileOpen;
  }

  logout(): void {
    const userType = this.userDetails?.userType;
    this.authService.logout();

    const redirectMap: Record<string, string> = {
      ADMIN: '/auth/login',
      ORGANIZER: '/auth/login',
      USER: '/auth/login',
      JUDGE: '/auth/judge-login'
    };

    this.router.navigate([redirectMap[userType ?? ''] || '/auth/login']);
  }

  // 👇 Close dropdown on outside click
  @HostListener('document:click', ['$event'])
  closeOnOutsideClick(event: Event): void {
    const target = event.target as HTMLElement;

    if (!target.closest('.position-relative')) {
      this.isProfileOpen = false;
    }
  }

}
